import ArtworkStyles from "./Artwork.module.css"
import BordersStyles from './Borders.module.css';
import { ArtworkLayout } from './Borders';
import { HeaderElement } from "./Header";
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";
import SigilDec from "./photos/BookDecorWebP/BookofAbdul_SigilDecoration.webp";
import ArtworkPiece1 from "./photos/BookContent/Artwork/Zellden_Ring_Logo_V3.png";
import ArtworkPiece2 from "./photos/BookContent/Artwork/Zellden_Ring_Logo_V2.png";
import ArtworkPiece3 from "./photos/BookContent/Artwork/Zellden_Ring_Logo_V1.png";
import ArtworkPiece4 from "./photos/BookContent/Artwork/Epic_Banner(Name)_V2.png";
import ArtworkPiece5 from "./photos/BookContent/Artwork/Epic_Banner(Plain)_V2.png";
import ArtworkPiece6 from "./photos/BookContent/Artwork/Epic_Banner(BW)_V2.png";
import ArtworkPiece7 from "./photos/BookContent/Artwork/The_Engravings_Collection.png";
import ArtworkPiece8 from "./photos/BookContent/Artwork/The_PantheonRadiance_Engravings(Treasure).png";
import ArtworkPiece9 from "./photos/BookContent/Artwork/PantheonRadianceLogo.png";
import ArtworkDownload1 from "./photos/BookContent/Artwork/SpilledDustImages.zip";
import ArtworkDownload2 from "./photos/BookContent/Artwork/ColorfulBannerImages.zip";
import ArtworkDownload3 from "./photos/BookContent/Artwork/EngravingsImages.zip";

/**
 * TODO: create thumbnails for all images.
 */

// Constants to store various images.
const open = 
    {
        title: "OpenBookCover",
        photo: OpenBookCover,
        id: 1
    };

const page = 
    {
        title: "IndividualPage",
        photo: IndividualPage,
        id: 2
    };

const decs = 
    {
        title: "SigilDecoration",
        photo: SigilDec,
        id: 3
    };
    
const front = 
    {
        title: "FrontBookCover",
        photo: FrontBookCover,
        id: 4
    };

const back =
    {
        title: "BackBookCover",
        photo: BackBookCover,
        id: 5
    };

const pagenums = 13; // Number of pages to render (may change in the future)

export function Artwork() {
    
    const Info = {
        maintitle: "The Alchemist's Cry Over Spilled Dust",
        description: `A logo I originally created for an Elden Ring-themed payment website in 2022, 
        then revamped in 2023 with my own design inspired by alchemy symbols.`,
        caption1: "Sans center design",
        caption2: "Original 2022 version",
        downloadlink: ArtworkDownload1,
        mainlink: "https://www.deviantart.com/pantheonradiance/gallery/88608132/the-alchemist-s-cry-over-spilled-dust"
    };
    const Photo1 = 
    {
        title: "Zell-den Ring Logo V3",
        photo: ArtworkPiece1,
        id: 1
    };
    const Photo2 = 
    {
        title: "Zell-den Ring Logo V2",
        photo: ArtworkPiece2,
        id: 2
    };
    const Photo3 = 
    {
        title: "Zell-den Ring Logo V1",
        photo: ArtworkPiece3,
        id: 3
    };

    // Trick to make animation play only on header click.
    let value = false;

    console.debug("HE: " + HeaderElement.GetHeader);

    if (HeaderElement.GetHeader === "BoA-header-artwork") {
        value = true;
    }
    console.debug("Test value? " + value);

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={ArtworkStyles["BoA-individual-pages"]} value={value}> 
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Artpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "1"}}>
                <ArtworkLayout 
                    section="Artwork" 
                    img1={decs.photo} 
                    alt1={decs.title}
                    img2={Photo1.photo}
                    alt2={Photo1.title}
                    img3={Photo2.photo}
                    alt3={Photo2.title}
                    img4={Photo3.photo}
                    alt4={Photo3.title}
                    title={Info.maintitle}
                    description={Info.description}
                    cap1={Info.caption1}
                    cap2={Info.caption2}
                    link1={Info.downloadlink}
                    link2={Info.mainlink}/>
            </div>  
        </section>
    );
}


export function Artwork2() {

    const Info = {
        maintitle: "Colorful Banner",
        description: `A banner I made out of an assortment of random experimental designs.
        A collage of colors if you will.`,
        caption1: "Original banner without text",
        caption2: "Black and white noir version",
        downloadlink: ArtworkDownload2,
        mainlink: "https://www.deviantart.com/pantheonradiance/gallery/95559845/profile-banner-images"
    };
    const Photo1 = 
    {
        title: "Epic Banner (Name)",
        photo: ArtworkPiece4,
        id: 1
    };
    const Photo2 = 
    {
        title: "Epic Banner (Plain)",
        photo: ArtworkPiece5,
        id: 2
    };
    const Photo3 = 
    {
        title: "Epic Banner (BW)",
        photo: ArtworkPiece6,
        id: 3
    };


    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={ArtworkStyles["BoA-individual-pages"]} id={ArtworkStyles["BoA-Artwork2-pages"]}> 
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Artpage2-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "2"}}>
                <ArtworkLayout 
                    section="Artwork" 
                    img1={decs.photo} 
                    alt1={decs.title}
                    img2={Photo1.photo}
                    alt2={Photo1.title}
                    img3={Photo2.photo}
                    alt3={Photo2.title}
                    img4={Photo3.photo}
                    alt4={Photo3.title}
                    title={Info.maintitle}
                    description={Info.description}
                    cap1={Info.caption1}
                    cap2={Info.caption2}
                    link1={Info.downloadlink}
                    link2={Info.mainlink}/>
            </div>  
        </section>
    );
}

export function Artwork3() {

    const Info = {
        maintitle: "The Engravings",
        description: `A collection of mosaic-like icons I made back in 2018.  
        Individual ones can be found on my DeviantArt page.`,
        caption1: "Treasure (extra recent mosaic)",
        caption2: "Extra name logo design",
        downloadlink: ArtworkDownload3,
        mainlink: "https://www.deviantart.com/pantheonradiance/gallery/88456788/the-pantheonradiance-engravings"
    };
    const Photo1 = 
    {
        title: "Engravings Collection",
        photo: ArtworkPiece7,
        id: 1
    };
    const Photo2 = 
    {
        title: "Treasure",
        photo: ArtworkPiece8,
        id: 2
    };
    const Photo3 = 
    {
        title: "PantheonRadiance Logo",
        photo: ArtworkPiece9,
        id: 3
    };

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={ArtworkStyles["BoA-individual-pages"]} id={ArtworkStyles["BoA-Artwork3-pages"]}> 
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Artpage3-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "3"}}>
                <ArtworkLayout 
                    section="Artwork" 
                    img1={decs.photo} 
                    alt1={decs.title}
                    img2={Photo1.photo}
                    alt2={Photo1.title}
                    img3={Photo2.photo}
                    alt3={Photo2.title}
                    img4={Photo3.photo}
                    alt4={Photo3.title}
                    title={Info.maintitle}
                    description={Info.description}
                    cap1={Info.caption1}
                    cap2={Info.caption2}
                    link1={Info.downloadlink}
                    link2={Info.mainlink}/>
            </div>  
        </section>
    );
}

 